class BaBaBabyProduct extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
    this.labels = JSON.parse(this.querySelector('[data-labels]').textContent);
    this.form = this.querySelector('form');
    this.form.noValidate = true;
    this.select = this.querySelector('[data-variant-select]');
    this.price = this.querySelector('[data-price]');
    this.mainImage = this.querySelector('[data-main-image]');
    this.buttons = [...this.querySelectorAll('[data-buy]')];
    this.querySelector('[data-option-pills]').hidden = false;
    this.querySelector('[data-select-wrap]').hidden = true;
    this.querySelector('[data-sticky]').hidden = false;
    this.gallery = [...this.querySelectorAll('[data-gallery]')];
    this.defaultGallery = this.gallery.map(thumb => ({src:thumb.dataset.src,alt:thumb.dataset.alt,style:thumb.dataset.galleryStyle || ''}));
    this.galleryIndex = 0;
    this.motionQuery = window.matchMedia?.('(prefers-reduced-motion: reduce)');
    this.querySelectorAll('[data-animation-src]').forEach(image => {
      this.setAnimation(image, !this.motionQuery?.matches);
    });
    if ('IntersectionObserver' in window) {
      this.buyObserver = new IntersectionObserver(entries => {
        this.querySelector('[data-sticky]').hidden = entries[0].isIntersecting || entries[0].boundingClientRect.top > 0;
      });
      this.buyObserver.observe(this.querySelector('button[type="submit"]'));
    }
    this.querySelectorAll('[data-size-option]').forEach(group => {
      [...group.querySelectorAll('[data-choice]')].sort((a,b) => parseFloat(a.dataset.sort) - parseFloat(b.dataset.sort)).forEach(choice => group.querySelector('[data-choices]').append(choice));
    });
    this.querySelectorAll('[data-option-group]:not([data-size-option])').forEach(group => {
      const choices = group.querySelectorAll('[data-option]');
      if (choices.length === 1) {
        choices[0].checked = true;
        group.hidden = true;
      }
    });
    this.buildFitGuide();
    this.addEventListener('change', event => {
      if (event.target.matches('[data-option]')) {
        this.updateVariant();
      }
      if (event.target.matches('[name="quantity"]')) this.updateVariant();
    });
    this.addEventListener('click', event => {
      const thumb = event.target.closest('[data-gallery]');
      if (thumb) {
        this.selectPhoto(this.gallery.indexOf(thumb));
      }
      const galleryStep = event.target.closest('[data-gallery-step]');
      if (galleryStep) this.selectPhoto(this.galleryIndex + Number(galleryStep.dataset.galleryStep));
      const unit = event.target.closest('[data-unit]');
      if (unit) this.setFitUnit(unit.dataset.unit);
      const sizeCard = event.target.closest('[data-size-card]');
      if (sizeCard && !sizeCard.disabled) {
        const radio = this.sizeRadios[Number(sizeCard.dataset.sizeCard)];
        if (radio) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', {bubbles:true}));
        }
      }
      if (event.target.closest('[data-fit-continue]')) {
        const radio = this.sizeRadios?.[this.fitIndex || 0];
        if (radio) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', {bubbles:true}));
          this.querySelector('[data-option-pills]').scrollIntoView({behavior:'smooth',block:'center'});
          this.querySelector('[data-status]').textContent = this.currentVariant ? '' : this.labels.sizeChosen;
        }
      }
      const animationButton = event.target.closest('[data-animation-toggle]');
      if (animationButton) {
        const image = animationButton.parentElement.querySelector('[data-animation-src]');
        this.setAnimation(image, animationButton.getAttribute('aria-pressed') !== 'true');
      }
      const quantity = event.target.closest('[data-quantity-step]');
      if (quantity) {
        const input = this.querySelector('[name="quantity"]');
        const step = Number(quantity.dataset.quantityStep);
        const max = input.max ? Number(input.max) : Infinity;
        input.value = Math.min(max, Math.max(Number(input.min) || 1, (Number(input.value) || 1) + step * (Number(input.step) || 1)));
        input.dispatchEvent(new Event('change', {bubbles:true}));
      }
      if (event.target.closest('[data-size-link]')) this.querySelector('[data-size-guide]')?.scrollIntoView({behavior:'smooth',block:'start'});
      if (event.target.closest('[data-sticky-buy]')) {
        if (!this.currentVariant) {
          this.querySelector('[data-option-pills]').scrollIntoView({behavior:'smooth',block:'center'});
          this.focusMissingOption();
        } else this.form.requestSubmit();
      }
    });
    this.form.addEventListener('submit', event => {
      if (!this.currentVariant?.available) {
        event.preventDefault();
        this.querySelector('[data-status]').textContent = this.labels.choose;
        this.querySelector('[data-option-pills]').scrollIntoView({behavior:'smooth',block:'center'});
        this.focusMissingOption();
      } else if (!this.querySelector('[name="quantity"]').checkValidity()) {
        event.preventDefault();
        this.querySelector('[name="quantity"]').reportValidity();
      } else {
        event.preventDefault();
        if (!this.addingMain) this.addMainWithOffer();
      }
    });
    this.updateVariant();
  }
  async addMainWithOffer() {
    this.addingMain=true;
    const button=this.form.querySelector('[data-buy]');button.disabled=true;
    const root=window.Shopify?.routes?.root||'/';
    const quantity=Number(this.form.querySelector('[name="quantity"]').value);
    const offer=this.querySelector('bbb-product-upsell');
    const modal=this.querySelector('[data-upsell-modal]');
    let cart;
    try {
      const response=await fetch(root+'cart.js',{headers:{Accept:'application/json'},cache:'no-store'});
      if(!response.ok)throw new Error('Cart unavailable');
      cart=await response.json();
    } catch(error) {this.form.submit();return;}
    if(cart.item_count!==0||quantity!==1||!offer?.products?.length||!modal?.showModal){this.form.submit();return;}
    try {
      const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:this.currentVariant.id,quantity}]})});
      const result=await response.json();
      if(!response.ok||result.status>=400)throw new Error(result.description||result.message||this.labels.unavailable);
      document.querySelectorAll('.cart-count').forEach(count=>count.textContent=String(cart.item_count+quantity));
      try {modal.showModal();} catch(error) {window.location.assign(root+'cart');}
    } catch(error) {this.querySelector('[data-status]').textContent=error.message||this.labels.unavailable;}
    finally {this.addingMain=false;button.disabled=false;}
  }
  updateVariant() {
    const groups = [...this.querySelectorAll('[data-option-group]')];
    const options = groups.map(group => group.querySelector('input:checked')?.value);
    const complete = options.every(value => value !== undefined);
    const variant = complete ? this.variants.find(item => item.options.every((value,index) => value === options[index])) : null;
    this.currentVariant = variant || null;
    this.select.value = variant ? String(variant.id) : '';
    this.querySelector('[data-status]').textContent = complete && !variant ? this.labels.unavailable : '';
    const label = !complete ? this.labels.choose : !variant ? this.labels.unavailable : !variant.available ? this.labels.soldOut : this.labels.add;
    this.buttons.forEach(button => {
      button.disabled = complete ? !variant?.available : false;
      const amount = (variant?.price || 0) * (Number(this.querySelector('[name="quantity"]').value) || 1);
      const total = variant?.price ? new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency:this.labels.currency || 'USD'}).format(amount / 100) : variant?.price_label;
      button.textContent = variant?.available ? label + ' — ' + total : label;
    });
    if (variant) {
      this.price.textContent = variant.price_label;
      const compare = this.querySelector('[data-compare]');
      compare.textContent = variant.compare_label || '';
      compare.hidden = !variant.compare_label;
      const input = this.querySelector('[name="quantity"]');
      input.min = variant.quantity_min || 1;
      input.step = variant.quantity_increment || 1;
      if (variant.quantity_max) input.max = variant.quantity_max;
      else input.removeAttribute('max');
      if (Number(input.value) < Number(input.min)) input.value = input.min;
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    }
    groups.forEach(group => {
      const chosen = group.querySelector('input:checked');
      group.querySelector('[data-chosen]').textContent = chosen ? chosen.dataset.label : this.labels.select;
    });
    const summary = this.querySelector('[data-selection-summary]');
    if (summary) summary.textContent = complete && variant ? groups.filter(group => !group.hidden).map(group => group.querySelector('input:checked')?.dataset.label).filter(Boolean).join(' · ') : this.labels.selectionHint;
    this.syncFitGuide();
    this.updateStyleGallery();
  }
  updateStyleGallery() {
    const group = this.querySelector('[data-option-group]:not([data-size-option])');
    if (!group || group.querySelectorAll('input').length < 2) return;
    const selected = group.querySelector('input:checked');
    if (!selected || selected.value === this.galleryStyle) return;
    this.galleryStyle = selected.value;
    const index = Number(selected.dataset.option);
    const exact = this.variants.find(variant => variant.options[index] === selected.value && variant.image);
    let photo = this.gallery.findIndex(thumb => thumb.dataset.galleryStyle === selected.value);
    if (photo < 0 && exact?.image) photo = this.gallery.findIndex(thumb => thumb.dataset.src.split('?')[0] === exact.image.split('?')[0]);
    if (photo >= 0) this.selectPhoto(photo);
  }
  renderGallery(photos) {
    const container = this.querySelector('.bbb-pdp-thumbs');
    if (!container) return;
    const buttons = photos.map((photo,index) => {
      const button = document.createElement('button');
      button.type = 'button';button.className = 'bbb-pdp-thumb';button.dataset.gallery = '';
      button.dataset.src = photo.src;button.dataset.alt = photo.alt || '';
      button.setAttribute('aria-label', photo.alt || `${this.labels.photo} ${index + 1}`);
      button.setAttribute('aria-pressed', String(index === 0));
      const image = document.createElement('img');image.src = photo.src;image.alt = '';image.loading = 'lazy';
      button.append(image);return button;
    });
    container.replaceChildren(...buttons);this.gallery = buttons;this.galleryIndex = 0;
    const nav = this.querySelector('.bbb-pdp-gallery-nav');
    if (nav) nav.hidden = photos.length < 2;
    this.selectPhoto(0);
  }
  focusMissingOption() {
    const group = [...this.querySelectorAll('[data-option-group]')].find(group => !group.querySelector('input:checked'));
    group?.querySelector('input')?.focus({preventScroll:true});
  }
  buildFitGuide() {
    const guide = this.querySelector('[data-fit-guide]');
    if (!guide) return;
    const table = guide.querySelector('[data-size-source] table');
    if (!table) return;
    const headers = [...table.querySelectorAll('thead th')].map(cell => cell.textContent.trim());
    this.sizeRows = [...table.querySelectorAll('tbody tr')].map(row => [...row.querySelectorAll('td')].map(cell => cell.textContent.trim()));
    this.sizeRadios = [...this.querySelectorAll('[data-size-option] [data-option]')];
    const cards = guide.querySelector('[data-fit-cards]');
    cards.style.setProperty('--size-count', this.sizeRows.length);
    this.sizeRows.forEach((row, index) => {
      const number = parseFloat(row[0]);
      const matchingRadio = this.sizeRadios.find(radio => parseFloat(radio.value) === number);
      const card = document.createElement('button');
      card.type = 'button';
      card.className = 'bbb-fit-card';
      card.dataset.sizeCard = String(index);
      card.dataset.sizeValue = matchingRadio?.value || '';
      card.setAttribute('aria-pressed', 'false');
      const title = document.createElement('strong');
      title.textContent = matchingRadio?.dataset.label || row[0].replace(/supplier code/gi, 'size code');
      card.append(title);
      const visual = document.createElement('span');
      visual.className = 'bbb-fit-baby';
      const svg = guide.querySelector('[data-baby-template]').content.cloneNode(true);
      visual.append(svg);
      visual.style.setProperty('--growth', index / Math.max(1, this.sizeRows.length - 1));
      card.append(visual);
      const measures = document.createElement('span');
      measures.className = 'bbb-fit-measures';
      row.slice(1).forEach((cell, column) => {
        const measure = document.createElement('span');
        const label = document.createElement('small');
        label.textContent = headers[column + 1];
        const value = document.createElement('b');
        value.dataset.measureCm = cell.match(/([\d.]+)\s*cm/)?.[1] || '';
        value.dataset.measureIn = cell.match(/([\d.]+)\s*in/)?.[1] || '';
        value.dataset.measureRaw = cell;
        measure.append(label, value);
        measures.append(measure);
      });
      card.append(measures);
      const prompt = document.createElement('span');
      prompt.className = 'bbb-fit-prompt';
      prompt.textContent = this.labels.chooseSize;
      card.append(prompt);
      cards.append(card);
    });
    this.sizeRadios = this.sizeRows.map(row => this.sizeRadios.find(radio => parseFloat(radio.value) === parseFloat(row[0])));
    this.showFitSelection(0);
    this.setFitUnit('in');
  }
  showFitSelection(index) {
    this.fitIndex = index;
    const card = this.querySelectorAll('[data-size-card]')[index];
    const panel = this.querySelector('[data-fit-selection]');
    if (!card || !panel) return;
    panel.querySelector('[data-fit-selection-title]').textContent = card.querySelector('strong').textContent + ' · ' + this.labels.measurements;
    const values = panel.querySelector('[data-fit-selection-values]');
    values.replaceChildren(...[...card.querySelector('.bbb-fit-measures').children].map(child => child.cloneNode(true)));
    this.setFitUnit(this.querySelector('[data-unit][aria-pressed="true"]')?.dataset.unit || 'in');
  }
  setFitUnit(unit) {
    this.querySelectorAll('[data-unit]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.unit === unit)));
    this.querySelectorAll('[data-measure-cm]').forEach(value => {
      const amount = unit === 'cm' ? value.dataset.measureCm : value.dataset.measureIn;
      value.textContent = amount ? amount + ' ' + unit : value.dataset.measureRaw;
    });
  }
  syncFitGuide() {
    if (!this.sizeRows) return;
    const checked = this.querySelector('[data-size-option] input:checked');
    const style = this.querySelector('[data-option-group]:not([data-size-option]) input:checked');
    const pantsOnly = this.querySelector('[data-size-source] th')?.textContent.includes('Pants');
    const notPants = pantsOnly && /hat only|shirt only/i.test(style?.dataset.label || '');
    const context = this.querySelector('[data-fit-context]');
    if (context) context.hidden = !notPants;
    this.querySelectorAll('[data-size-card]').forEach(card => {
      card.disabled = Boolean(notPants || !card.dataset.sizeValue);
      card.setAttribute('aria-pressed', String(Boolean(!notPants && checked && card.dataset.sizeValue === checked.value)));
    });
    const selected = this.sizeRadios.findIndex(radio => radio?.value === checked?.value);
    if (selected >= 0) this.showFitSelection(selected);
    const continueButton = this.querySelector('[data-fit-continue]');
    if (continueButton) continueButton.disabled = Boolean(notPants || !this.sizeRadios[this.fitIndex || 0]);
  }
  selectPhoto(index) {
    if (!this.gallery.length) return;
    this.galleryIndex = (index + this.gallery.length) % this.gallery.length;
    const thumb = this.gallery[this.galleryIndex];
    this.showImage(thumb.dataset.src, thumb.dataset.alt);
    this.gallery.forEach(button => button.setAttribute('aria-pressed', String(button === thumb)));
    this.querySelector('[data-gallery-count]').textContent = `${this.galleryIndex + 1} / ${this.gallery.length}`;
  }
  setAnimation(image, playing) {
    image.src = playing ? image.dataset.animationSrc : image.dataset.poster;
    const button = image.parentElement.querySelector('[data-animation-toggle]');
    button.textContent = playing ? this.labels.pause : this.labels.play;
    button.setAttribute('aria-pressed', String(playing));
  }
  showImage(src, alt) {
    if (!this.mainImage || !src) return;
    this.mainImage.removeAttribute('srcset');
    this.mainImage.removeAttribute('sizes');
    this.mainImage.src = src;
    this.mainImage.alt = alt || '';
  }
}
if (!customElements.get('bbb-product-page')) customElements.define('bbb-product-page', BaBaBabyProduct);

class BaBaBabyReviewCarousel extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.track = this.querySelector('[data-review-track]');
    this.slides = [...this.querySelectorAll('[data-review-slide]')];
    if (!this.track) return;
    this.randomizeReviews();
    this.slides = [...this.querySelectorAll('[data-review-slide]')];
    this.index = 0;
    this.fitHeight = () => { if (this.slides[this.index]?.offsetHeight) this.track.style.height = this.slides[this.index].offsetHeight + 'px'; };
    if (typeof requestAnimationFrame === 'function') requestAnimationFrame(this.fitHeight);
    this.ownerDocument.fonts?.ready.then(this.fitHeight);
    this.resizeObserver = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(this.fitHeight) : null;
    this.resizeObserver?.observe(this.track);
    this.track.addEventListener('keydown', event => {
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
        event.preventDefault();
        this.index = Math.max(0, Math.min(this.slides.length - 1, this.index + (event.key === 'ArrowRight' ? 1 : -1)));
        const reduced = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollTo({left: this.slides[this.index].offsetLeft - this.slides[0].offsetLeft, behavior: reduced ? 'auto' : 'smooth'});
      }
    });
    this.track.addEventListener('scroll', () => {
      const first = this.slides[0].offsetLeft;
      const distances = this.slides.map(slide => Math.abs(slide.offsetLeft - first - this.track.scrollLeft));
      this.index = distances.indexOf(Math.min(...distances));
      this.fitHeight();
    }, {passive:true});
    this.abort = new AbortController();
    const options = {signal:this.abort.signal};
    this.addEventListener('mouseenter', () => { this.hovered = true; this.stop(); }, options);
    this.addEventListener('mouseleave', () => { this.hovered = false; this.start(); }, options);
    this.addEventListener('focusin', () => this.stop(), options);
    this.addEventListener('focusout', () => this.start(), options);
    this.ownerDocument.addEventListener('visibilitychange', () => this.ownerDocument.hidden ? this.stop() : this.start(), options);
    this.start();
  }
  randomizeReviews() {
    const root = this.closest('bbb-product-page');
    const candidates = [...(root?.querySelectorAll('[data-review-entry]') || [])].filter(card => !card.hasAttribute('data-incentivized') && card.querySelector('.bbb-external-stars')?.getAttribute('aria-label') === '5 / 5' && card.querySelector('blockquote')?.textContent.trim() && card.querySelector('blockquote').textContent.length < 350);
    if (!candidates.length || !this.slides[0]) return;
    for (let i=candidates.length-1;i>0;i--) { const j=Math.floor(Math.random()*(i+1)); [candidates[i],candidates[j]]=[candidates[j],candidates[i]]; }
    const key = 'bbb-review-highlights-' + root.dataset.productId;
    try {
      const prior = sessionStorage.getItem(key);
      if (candidates.length > 1 && candidates.slice(0,4).map(c=>c.querySelector('strong')?.textContent+c.querySelector('blockquote').textContent).join('|') === prior) candidates.push(candidates.shift());
      sessionStorage.setItem(key,candidates.slice(0,4).map(c=>c.querySelector('strong')?.textContent+c.querySelector('blockquote').textContent).join('|'));
    } catch {}
    const template = this.slides[0];
    this.track.replaceChildren(...candidates.slice(0,4).map(source => {
      const slide = template.cloneNode(true);
      slide.querySelector('blockquote').textContent = source.querySelector('blockquote').textContent;
      slide.querySelector('.bbb-review-person strong').textContent = source.querySelector('strong')?.textContent || 'Customer';
      return slide;
    }));
  }
  start() {
    this.stop();
    if (this.slides.length < 2 || this.hovered || this.contains(this.ownerDocument.activeElement) || this.ownerDocument.hidden || window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) return;
    this.timer = setInterval(() => {
      this.index = (this.index + 1) % this.slides.length;
      this.track.scrollTo({left:this.slides[this.index].offsetLeft-this.slides[0].offsetLeft,behavior:'smooth'});
      this.fitHeight();
    }, 5500);
  }
  stop() { clearInterval(this.timer); }
  disconnectedCallback() { this.stop(); this.abort?.abort(); this.resizeObserver?.disconnect(); this.ready = false; }
}
if (!customElements.get('bbb-review-carousel')) customElements.define('bbb-review-carousel', BaBaBabyReviewCarousel);

class BaBaBabyReviewList extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.entries = [...this.querySelectorAll('[data-review-entry]')];
    this.visible = Math.min(5,this.entries.length);
    this.button = this.querySelector('[data-review-more]');
    this.button.addEventListener('click', () => {this.visible = Math.min(this.visible+5,this.entries.length);this.renderPage();this.querySelector('[data-review-page-status]').textContent = this.visible + ' of ' + this.entries.length + ' reviews';});
    this.renderPage();
  }
  renderPage() {this.entries.forEach((card,index)=>card.hidden=index>=this.visible);this.button.hidden=this.visible>=this.entries.length;}
}
if (!customElements.get('bbb-review-list')) customElements.define('bbb-review-list',BaBaBabyReviewList);

class BaBaBabyProductUpsell extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.products = JSON.parse(this.querySelector('[data-upsell-products]').textContent);
    if (!this.products.length) return;
    this.labels = JSON.parse(this.querySelector('[data-upsell-labels]').textContent);
    this.page = this.closest('bbb-product-page');
    this.status = this.querySelector('[data-upsell-status]');
    this.button = this.querySelector('[data-upsell-add]');
    this.thumbnails = this.querySelector('[data-upsell-thumbnails]');
    this.products.forEach((product,index) => {
      const button = document.createElement('button');
      button.type = 'button';button.setAttribute('aria-label',product.title);button.setAttribute('aria-pressed','false');
      const image = document.createElement('img');image.src = product.flat;image.alt = product.title;image.width = 64;image.height = 64;image.loading = 'lazy';
      button.append(image);button.addEventListener('click',()=>{if(this.index!==index)this.selectProduct(index);this.openPreview();});this.thumbnails.append(button);
    });
    this.page.addEventListener('change',event=>{
      if (event.target.matches('[data-option]') && event.target.closest('[data-size-option]')) this.matchSize();
    });
    this.querySelector('[data-upsell-form]').addEventListener('submit',event=>{event.preventDefault();this.addExtra();});
    const modal=this.closest('[data-upsell-modal]');
    const goToCart=()=>{window.location.assign(this.labels.cartUrl||((window.Shopify?.routes?.root||'/')+'cart'));};
    modal.querySelector('[data-upsell-close]').addEventListener('click',goToCart);
    modal.addEventListener('cancel',event=>{event.preventDefault();goToCart();});
    this.hidden = false;
    this.selectProduct(0);
  }
  age(label) {return (label?.match(/\d+/g)||[]).join('-');}
  openPreview() {
    this.previewIndex=this.index;
    this.thumbnails.children[this.index].classList.add("is-preview");
    this.update();
  }
  selectProduct(index) {
    this.index = index;this.product = this.products[index];this.selection = [];this.previewIndex=null;
    [...this.thumbnails.children].forEach((button,i)=>{button.classList.remove("is-preview");button.querySelector("img").src=this.products[i].flat;});
    [...this.thumbnails.children].forEach((button,i)=>button.setAttribute('aria-pressed',String(i===index)));
    const title = this.querySelector('[data-upsell-title]');title.textContent = this.product.title;title.href = this.product.url;
    const options = this.querySelector('[data-upsell-options]');options.replaceChildren();
    this.product.options.forEach(option=>{
      if (!option.size && option.values.length===1) {this.selection[option.position]=option.values[0].value;return;}
      const label = document.createElement('label');label.append(document.createTextNode(option.size?this.labels.size:this.labels.style));
      const select = document.createElement('select');select.dataset.upsellOption = option.position;select.required = true;
      const placeholder = document.createElement('option');placeholder.value = '';placeholder.textContent = option.size?this.labels.chooseSize:this.labels.chooseStyle;select.append(placeholder);
      const values = [...option.values];if(option.size)values.sort((a,b)=>parseFloat(a.label)-parseFloat(b.label));
      values.forEach(value=>{const item = document.createElement('option');item.value=value.value;item.textContent=value.label;select.append(item);});
      if (!option.size) {
        const available = values.find(value=>this.product.variants.some(variant=>variant.available&&variant.options[option.position]===value.value));
        if(available){select.value=available.value;this.selection[option.position]=available.value;}
      }
      select.addEventListener('change',()=>{this.selection[option.position]=select.value;this.status.textContent='';this.update();});label.append(select);options.append(label);
    });
    this.status.textContent='';this.matchSize();
  }
  matchSize() {
    const main = this.page.querySelector('[data-size-option] input:checked');
    const size = this.product.options.find(option=>option.size);
    if (!size) {this.update();return;}
    const select = this.querySelector('[data-upsell-option="'+size.position+'"]');
    const match = main && size.values.find(value=>this.age(value.label)===this.age(main.dataset.label));
    select.value = match?.value || '';this.selection[size.position]=select.value;
    this.querySelector('[data-upsell-hint]').textContent=main&&!match?this.labels.differentSizes:'';
    this.update();
  }
  update() {
    const complete = this.product.options.every(option=>this.selection[option.position]);
    this.variant = complete?this.product.variants.find(variant=>variant.options.every((value,index)=>value===this.selection[index])):null;
    const style = this.product.options.find(option=>!option.size);
    const preview = this.product.variants.find(variant=>variant.available&&(!style||!this.selection[style.position]||variant.options[style.position]===this.selection[style.position]));
    const photo=this.variant||preview;
    this.thumbnails.children[this.index].querySelector('img').src=this.previewIndex===this.index?(photo?.model||this.product.model):(photo?.flat||this.product.flat);
    this.querySelector('[data-upsell-price]').textContent=(this.variant||preview)?.price||'';
    this.querySelectorAll('[data-upsell-option]').forEach(select=>{
      [...select.options].forEach(option=>{
        if(!option.value)return;
        option.disabled=!this.product.variants.some(variant=>variant.available&&variant.options[Number(select.dataset.upsellOption)]===option.value&&this.product.options.every(other=>other.position===Number(select.dataset.upsellOption)||!this.selection[other.position]||variant.options[other.position]===this.selection[other.position]));
      });
    });
    this.button.disabled=this.busy||(complete&&!this.variant?.available);
    this.button.textContent=this.busy?this.labels.adding:complete&&!this.variant?.available?this.labels.soldOut:this.labels.add;
  }
  async addExtra() {
    if(this.busy)return;
    if(!this.variant?.available){this.status.textContent=this.labels.chooseExtra;this.querySelector('select:invalid')?.focus();return;}
    this.busy=true;this.update();
    try {
      const root=window.Shopify?.routes?.root||'/';
      const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:this.variant.id,quantity:1}]})});
      const result=await response.json();
      if(!response.ok||result.status>=400)throw new Error(result.description||result.message||this.labels.error);
      window.location.assign('/checkout');
    }catch(error){this.status.textContent=error.message||this.labels.error;this.busy=false;this.update();}
  }
}
if(!customElements.get('bbb-product-upsell'))customElements.define('bbb-product-upsell',BaBaBabyProductUpsell);
